import lpApp from '../lp_app';
import {formatMobilePhone} from '../../logic/utils/phoneNumber'

/*
 * Project: LegalPlace assistant
 * File: src/app/ops/SendInBlue.js
 * Author: Amine Azizi
 * Version: 1.0
*/

export default class LpSendInBluekOps {
  constructor() {
    this.sendinblueVars = {};
  }

  sendInBlueNotification(_obj = {}, isAssist = false, callback = () => {}) {

      // console log senindblue
      console.log("SB isAssist", isAssist)
      try {
      if (!isAssist) {
          const userEmail = lpApp.getState().account_settings.mail;
          // Test if execute script here
          console.log("mail", lpApp.getState().account_settings.mail)
          let chosenPack;
          let price;
          if (lpApp.store.getState().appstate === 2 || lpApp.store.getState().appstate === 1 || lpApp.store.getState().appstate === 3){
            const chosen = lpApp.store.getState().checkout_operations.pack;
            if (chosen === 0) chosenPack = 'Third Pack';
            else if (chosen === 1) chosenPack = 'Second Pack';
            else chosenPack = 'Firs Pack';

            this.sendinblueVars = {
              "email_id": userEmail.toLowerCase(),
              "Client_type": (lpApp.getState().contract.client_type) ? 'pro' : 'ind',
              "Document": lpApp.getState().contract.name,
              "UNIQID": lpApp.contractUniqid,
              "Reprise": "www.legalplace.fr/contrats/" + lpApp.contractTitle + "/continuer/" + lpApp.contractUniqid + "?ref=relmail",
              "CHOSEN_PACK": chosenPack,
              "PRICE": price,
              "AB": Math.floor(Math.random() * 2),
              'C_CODE_10': _obj.c_codes && _obj.c_codes[0] ? _obj.c_codes[0] : '',
              'C_CODE_20': _obj.c_codes && _obj.c_codes[1] ?_obj.c_codes[1] : '',
              'C_CODE_30': _obj.c_codes && _obj.c_codes[2] ? _obj.c_codes[2] : '',
              'CODE_PARRAINAGE': _obj.refferal_code,
              'TELECHARGEMENT': "www.legalplace.fr/rt/" + lpApp.contractUniqid,
              'CODE_PARRAINAGE_USAGE': _obj.refferal_code_usage,
              'CHECKOUT': "www.legalplace.fr/contrats/" + lpApp.contractTitle + "/" + lpApp.contractUniqid + "/paiement?ref=relmail",
              'DOCUMENT': lpApp.getState().contract.name,
              'CHECKOUTS_COUNT': _obj.counts ?_obj.counts.checkouts_count : '',
              //'CHECKOUTS_MOD_4': _obj.counts ? _obj.counts.checkouts_mod_4 : '',
              'DESABONNEMENT': _obj.desabonnement,
              'URL_ENTREE': localStorage.getItem('URL_ENTREE')
              //'ML_LINK': _obj.ml_link
            };

            // Sendinblue password var
            if(_obj.pwd !== false){
              this.sendinblueVars['PWD'] = _obj.pwd;
            }
          }

          if (_obj.counts) {
            var CMODF = _obj.counts.checkouts_mod_4;
            this.sendinblueVars["DOCUMENT_"+CMODF] = lpApp.getState().contract.name;
            this.sendinblueVars["REPRISE_"+CMODF] = "www.legalplace.fr/contrats/" + lpApp.contractTitle + "/continuer/" + lpApp.contractUniqid + "?ref=relmail";
            this.sendinblueVars["CHECKOUT_"+CMODF] = "www.legalplace.fr/contrats/" + lpApp.contractTitle + "/" + lpApp.contractUniqid + "/paiement?ref=relmail";
            this.sendinblueVars["CHECKOUT"] = this.sendinblueVars["CHECKOUT_"+CMODF]
            this.sendinblueVars["DOCUMENT"] = this.sendinblueVars["DOCUMENT_"+CMODF]
          }

      }
         // Test if execute script here
          const userEmail = lpApp.getState().account_settings.mail ||  _obj.user.email;
          const sib = lpApp.references.slack_notification.sendinblue;
          try {
            sib.forEach((idx) => {
              if (idx.name === "TEL") {
                this.sendinblueVars[idx.name] = idx.type === 'option'
                ? lpApp.indexes.options.getOption(idx.id) ? lpApp.indexes.options.getOption(idx.id).value : 'No value'
                : lpApp.indexes.variables.getVariable(idx.id) ? lpApp.indexes.variables.getVariable(idx.id).value : 'No value';
                const smsNumber = lpApp.indexes.variables.getVariable(idx.id) ? formatMobilePhone(lpApp.indexes.variables.getVariable(idx.id).value) : ''
                if (smsNumber) this.sendinblueVars["SMS"] = smsNumber
              }
            });
          } catch (error) {
            console.error('variable extraxction failed', error)
          }

          console.log("Info SendinBlue", this.sendinblueVars)
          console.log("email-user:", userEmail)
        if (typeof (window.sendinblue) !== 'undefined') {
          window.sendinblue.identify(userEmail.toLowerCase(), this.sendinblueVars);
          setTimeout(function () {
            callback()
          }, 500)
        }
        // Track Datalayer
        lpApp.ops.slack.sendExtractionAttributesSBToDatalayer(this.sendinblueVars)
      }
      catch(err) {
          console.log(`SB error ${err}`)
      }
  }
}



// WEBPACK FOOTER //
// ./src/app/ops/sendinblue_notification.js